import React from 'react';

export default function AuthStatus({ auth }) {
  const isAuth    = auth.status === 'AUTHENTICATED';
  const isPending = auth.status === 'PENDING';
  const isRejected = auth.status === 'REJECTED';

  const cfg = isPending
    ? { color: '#6366f1', bg: '#eef2ff', border: '#c7d2fe', icon: '⏳', label: 'Awaiting Auth', sub: 'ECG enrollment in progress', grad: 'linear-gradient(135deg, #eef2ff, #e0e7ff)' }
    : isAuth
    ? { color: '#059669', bg: '#ecfdf5', border: '#a7f3d0', icon: '✓',  label: 'Authenticated', sub: 'Cross-correlation ≥ 0.75 · Identity verified', grad: 'linear-gradient(135deg, #ecfdf5, #d1fae5)' }
    : { color: '#dc2626', bg: '#fff1f2', border: '#fecaca', icon: '✕',  label: 'Auth Rejected',  sub: 'Waveform mismatch · Re-authenticate required', grad: 'linear-gradient(135deg, #fff1f2, #ffe4e6)' };

  return (
    <div style={{ ...s.card, background: cfg.grad, borderColor: cfg.border }}>
      {/* Icon */}
      <div style={{ ...s.iconCircle, background: cfg.color + '15', border: `1.5px solid ${cfg.border}` }}>
        <span style={{ ...s.iconText, color: cfg.color, fontSize: isAuth || isRejected ? 20 : 16 }}>
          {cfg.icon}
        </span>
      </div>

      {/* Text */}
      <div style={s.textBlock}>
        <div style={s.topRow}>
          <span style={s.sectionLabel}>ECG Biometric Auth</span>
          <div style={{ ...s.statusBadge, background: cfg.color + '15', color: cfg.color, border: `1px solid ${cfg.border}` }}>
            <span style={{ ...s.dot, background: cfg.color, animation: isAuth ? 'pulse-ring 2s infinite' : 'none' }} />
            {auth.status}
          </div>
        </div>
        <span style={{ ...s.labelText, color: cfg.color }}>{cfg.label}</span>
        <span style={s.subText}>{cfg.sub}</span>
      </div>

      {/* Waveform decoration */}
      <svg width="60" height="36" viewBox="0 0 60 36" fill="none" style={{ opacity: 0.18, flexShrink: 0 }}>
        <path d="M0 18 H10 L14 4 L20 32 L26 10 L30 18 H40 L44 12 L48 24 L52 18 H60"
          stroke={cfg.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}

const s = {
  card: {
    flex            : 1,
    minWidth        : 260,
    backdropFilter  : 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderRadius    : 20,
    border          : '1px solid',
    boxShadow       : '0 4px 24px rgba(99,102,241,0.07)',
    padding         : '18px 20px',
    display         : 'flex',
    alignItems      : 'center',
    gap             : 14,
  },
  iconCircle: {
    width       : 48,
    height      : 48,
    borderRadius: '50%',
    display     : 'flex',
    alignItems  : 'center',
    justifyContent: 'center',
    flexShrink  : 0,
  },
  iconText  : { fontWeight: 700 },
  textBlock : { flex: 1, display: 'flex', flexDirection: 'column', gap: 3 },
  topRow    : { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 },
  sectionLabel: { fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.07em' },
  statusBadge : {
    display     : 'flex',
    alignItems  : 'center',
    gap         : 5,
    fontSize    : 10,
    fontWeight  : 700,
    padding     : '3px 8px',
    borderRadius: 99,
    letterSpacing: '0.04em',
  },
  dot       : { width: 6, height: 6, borderRadius: '50%', flexShrink: 0 },
  labelText : { fontSize: 15, fontWeight: 700, marginTop: 1 },
  subText   : { fontSize: 11, color: '#6b7280', fontWeight: 500, lineHeight: 1.4 },
};
